import { ADDON } from "constants/types";

const initState = {
  addons: null
}


const AddonsReducer = (state = initState, action) => {

  const { type, payload, id } = action;

  switch(type) {

    case ADDON.ADD: {

      let updated = {};

      if(state.addons && state.addons[id]) {
        updated = {
          ...state.addons,
          [id]: [...state.addons[id], payload]
        }
      } else {
        updated = {
          ...state.addons,
          [id]: [payload]
        }
      }

      return {
        ...state,
        addons: updated
      }

    }


    case ADDON.REMOVE: {

      let updated = {};

      updated = {
        ...state.addons,
        [id]: state.addons[id].filter(item => item.uniqid !== payload.uniqid)
      }

      if(updated[id] && !updated[id].length) {
        delete updated[id]
      }

      return {
        ...state,
        addons: updated
      }
    }

    case ADDON.CLEAR:
      return {
        ...state,
        addons: null
      }

    default:
      return state
  }
}

export default AddonsReducer